import { FC } from 'react';
import { TableCellProps } from '@servicetitan/table';

import { OutboundMessage } from '../api/telecom.api';
import { formatTelecomDate } from '../utils/date-format';

export const DateCell: FC<TableCellProps<OutboundMessage>> = ({ dataItem }) => (
    <td>{formatTelecomDate(dataItem.dateCreated)}</td>
);
